import React from 'react';
import { getIconUrl } from '../utils';

const ICON_NAME = 'image';

export const Color = {
  BLACK: 'black',
  GREY: 'grey',
  GRAY: 'grey',
  DEFAULT: 'black',
};

const PhotoIcon = ({ color = Color.DEFAULT, ...otherProps } = {}) => {
  return (
    // eslint-disable-next-line jsx-a11y/img-redundant-alt
    <img
      {...otherProps}
      src={getIconUrl({
        name: ICON_NAME,
        color,
      })}
      alt="Photo Icon"
    />
  );
};

export default PhotoIcon;
